import React from 'react';
import { observer } from 'mobx-react';

import { AntSelect } from './ant/ant-select/antSelect';
import { apiFetchObservable } from 'framework/api';
import { getTimeZones } from 'areas/administration/calendar/api';
import { fromStringsArray } from 'controls/react/ant/ant-select/utils/fromStringsArray';

export class TimeZoneSelectorProps {
	value?: string;
	onChange?: (value: string) => void;
}

export const TimeZoneSelector = observer((props: TimeZoneSelectorProps) => {
	const timeZones = apiFetchObservable(getTimeZones());

	return (
		<AntSelect
			options={fromStringsArray(timeZones.data)}
			loading={timeZones.loading}
			value={props.value}
			onChange={props.onChange}
		/>
	);
});
